import { BaseType } from '../../base/base-type';
import { ContributionRateCalculationType } from '../enum/contribution-rate-calculation-type';

export class DesignatedUnitContributionRateCalculationType extends BaseType {
  public declare id: ContributionRateCalculationType;
}
